import { GridColDef, GridRowsProp } from '@mui/x-data-grid';
import { useContext, useEffect, useState } from 'react';
import { AppContext } from '../../../app-context';
import IGridComponent from '../../../components/grid/i-grid.component';
import { PAGE_SIZE} from '../../common/constants';
import { formatDateLong, formatTo0Decimal } from '../../common/util.services';
import { getAllLedger } from '../order.services';
import './stock.component.scss';
import { getMasterDataById } from '../../master-data/masterdata.services';
import IDialogComponent from '../../../components/dialog/i-dialog.component';
import SpecsComponent from '../../master-data/specs/specs.component';

const AllLedger = () => {
  const appContext = useContext(AppContext);
  const rows: GridRowsProp = [];
  const [stockData, setStockData] = useState(rows);
  const [specsData, setSpecsData] = useState(null);
  const [openSpecs, setOpenSpecs] = useState(false);
  const columns: GridColDef[] = [
    { field: 'inputCode', headerName: 'Item Code', filterable: false, sortable: false, editable: false, width: 85,
      cellClassName: (params) => { return getClassName(params)},
      renderCell: (params) => { return <div className="cell-link" 
      onClick={() => {openSpecsPopup(params.row.inputId)}}>{params.row.inputCode}</div> }
    },
    { field: 'inputDesc', headerName: 'Description', filterable: false, sortable: false, editable: false, width: 250,
      cellClassName: (params) => { return getClassName(params)},
    },
    { field: 'orderCode', headerName: 'Order Code', filterable: false, sortable: false, editable: false, width: 125,
      cellClassName: (params) => { return getClassName(params)},
    },
    { field: 'location', headerName: 'Location', filterable: false, sortable: false, editable: false, width: 250,
      cellClassName: (params) => { return getClassName(params)},
    },
    { field: 'quantity', headerName: 'Quantity', filterable: false, sortable: false, editable: false, width: 110,
      cellClassName: (params) => { return getClassName(params)},
      renderCell: (params) => {return formatTo0Decimal(params.row.quantity) + ' ' + params.row.inputUom},
    },
    { field: 'balanceQty', headerName: 'Balance', filterable: false, sortable: false, editable: false, width: 110,
      cellClassName: (params) => { return getClassName(params)},
      renderCell: (params) => {return formatTo0Decimal(params.row.balanceQty) + ' ' + params.row.inputUom},
    },
    { field: 'challanDate', headerName: 'Challan Date', filterable: false, sortable: false, editable: false, width: 180,
      cellClassName: (params) => { return getClassName(params)},
      valueFormatter: (challanDate: any) => formatDateLong(challanDate)
    }
  ];
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(PAGE_SIZE);
  const [totalRows, setTotalRows] = useState(0);

  useEffect(() => {
    getAllLedger(page, pageSize, appContext,
      (response: any) => {
        setStockData(response.data.data);
        setTotalRows(response.data.totalElements);
        appContext.setShowLoader(false);
        setLoading(false);
      }, (error: any) => {
        appContext.setShowLoader(false);
        appContext.setErrorMessage(error.message);
        setLoading(false);
      });
  }, [page, pageSize]);

  const closeSpecs = () => {
    setOpenSpecs(false);
  }

  function getClassName(params: any) {
    if('balanceQty' === params.field && params.row.balanceQty < -0.01) {
      return 'ledgerNegative';
    } else if(0 === params.row.ledgerId) {
      return 'ledger1';
    } else {
      return 'ledger2';
    }
  }

  const openSpecsPopup = (inputId: any) => {
    setLoading(true);
    getMasterDataById(inputId, appContext,
      (response: any) => {
        appContext.setShowLoader(false);
        setLoading(false);
        setSpecsData(response.data);
        setOpenSpecs(true);
      }, (error: any) => {
        console.log(error);
        appContext.setShowLoader(false);
        appContext.setErrorMessage(error.message);
        setLoading(false);
      });
  };

  const onPaginationModelChange = (evt: any) => {
    setPage(evt.page);
    setPageSize(evt.pageSize);
  }

  return <>
    <IGridComponent title={''} rows={stockData} columns={columns} loading={loading} maxHeight={600} paginationType="server" 
      paginationModelChange={onPaginationModelChange} totalRows={totalRows} disableRowSelectionOnClick={true}
      showAddBtn={false} showApproveAction={false} showDeleteAction={false} showUpAction={false} showDownAction={false}
      getRowId={(row: any) => row.id} />
    <IDialogComponent onClose={closeSpecs} open={openSpecs} title='Specifications' dialogClass={'spec-panel'} 
      dialogBody={<SpecsComponent data={specsData} />} />
  </>
}

export default AllLedger;